module.exports = __webpack_public_path__ + "assets/mail_icon.5a77fbe8.svg";